<template>
	<div name="hres6ae-popup" id="hres6ae-popup" class="modal fade modal-full-width" role="dialog">
		<div class="modal-dialog">

		  <div class="modal-content">
		    <div class="modal-header header-popup">
		      <button type="button" class="close" data-dismiss="modal">&times;</button>
		      <h4 class="modal-title">{{ labels['STDATTEN']['10'] }}</h4>
		    </div>
		    <div class="modal-body">
					<hrms-table :columns="columnsDetailPopup" 
											:data="detailPopup.table"
											:maxRowspan="maxRowspanPopup" />
		    </div>
		  </div>

		</div>
	</div>
</template>

<script>
export default {
  name: 'hres6ae-popup',
  data () {
    return {
      btn_close: 'Close'
    }
  },
  props: [ 'labels', 'detailPopup', 'columnsDetailPopup', 'maxRowspanPopup' ]
}
</script>





// WEBPACK FOOTER //
// popup.vue?67b753a5